import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DOCUMENT} from '@angular/common';
import {Select} from '@angular-redux3/store';
import {Observable, Subscription} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {AudioService} from '../../../services/audio.service';
import {Media} from '../../../store/entities';

declare const soundManager: any;

@Component({
  selector: 'mwo-playback-dialog',
  templateUrl: './playback-dialog.component.html',
  styleUrls: ['./playback-dialog.component.scss']
})
export class PlaybackDialogComponent implements OnInit, OnDestroy {
  @Select(['player', 'media', 'id']) mediaId$: Observable<string>;
  @Select(['player', 'currentPosition']) currentPosition$: Observable<number>;
  @Select(['player', 'state']) state$: Observable<string>;
  @Select(['player', 'media']) currentMedia$: Observable<Media>;

  songs: any[];
  songTitleToDisplay: string = '';
  artistNameToDisplay: string = '';
  private position: number;
  private subscription$: Subscription;
  private stateSubscription$: Subscription;
  private currentMediaSubscription$: Subscription;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              @Inject(DOCUMENT) private document,
              private audioService: AudioService
  ) {
  }

  ngOnInit(): void {
    this.currentMediaSubscription$ = this.currentMedia$.subscribe(res => {
      if (res && res.id) {
        this.songTitleToDisplay = res.title;
        if (res.artist) {
          if (typeof res.artist === 'string') {
            this.artistNameToDisplay = res.artist;
          } else {
            this.artistNameToDisplay = res.artist.name;
          }
        }
      }
    });
    this.soundManagerSetup();
    this.getCurrentPosition();
    this.playSong();
  }

  soundManagerSetup() {
    soundManager.setup({
      debugMode: false,
      defaultOptions: {
        useHighPerformance: true,
        stream: false,
        onfinish: () => {
          // console.log('onfinish');
          // this._musicPlayerService.nextTrack();
        }
      }
    });
  }

  playSong() {
    this.subscribe();
  }

  subscribe() {
    if (this.data.isPassivePlayback) {
      this.songs = [{
        id: this.data.id,
        url: environment.urlPlaybackMedia
          + this.data.id,
      }];
      this.audioService.setAudioAtPos(this.songs[0].url, this.position);
    } else {
      this.subscription$ = this.mediaId$.subscribe(mediaId => {
        if (mediaId) {
          this.songs = [{
            id: mediaId,
            url: environment.urlPlaybackMedia + mediaId,
          }];
          this.audioService.setAudioAtPos(this.songs[0].url, this.position);
        }
      });
    }
    this.stateSubscription$ = this.state$.subscribe(res => {
      if (res !== 'PLAYING') {
        this.audioService.pauseAudio();
      } else {
        this.audioService.playAudio();
      }
    });
  }

  getCurrentPosition() {
    if (this.data.isPassivePlayback) {
      this.position = 0;
    } else {
      this.currentPosition$.subscribe(result => {
        this.position = result;
      });
    }
  }

  ngOnDestroy(): void {
    if (!this.data.isPassivePlayback) {
      this.subscription$.unsubscribe();
    }
    this.stateSubscription$.unsubscribe();
    this.currentMediaSubscription$.unsubscribe();
  }
}
